export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const GRAPHQL_API = import.meta.env.VITE_GRAPHQL_API;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;